import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    scoreboardContainer: {
        backgroundColor: "black",
        minHeight: "4vw",
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        flexFlow: "wrap",
    },

    scoreboardContainerOneButton: {
        backgroundColor: "black",
        minHeight: "10%",
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        flexFlow: "wrap",
    },

    scoreboardButtonLeftGroup: {
        float: "left",
        marginTop: "1%",
        marginLeft: "1%",
        display: "table-cell",
    },
    scoreboardButtonRightGroup: {
        float: "left",
        marginTop: "1%",
        marginRight: "1%",
        display: "table-cell",
    },
}));

export { useStyles };
